/* src/app/builder-screen-beta/components/optimized-auto-screen-generator/optimized-auto-screen-generator.component.scss */
::ng-deep .optimized-generator-modal .ant-modal-header {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
}
::ng-deep .optimized-generator-modal .ant-modal-header .ant-modal-title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}
::ng-deep .optimized-generator-modal .ant-modal-close-x {
  color: white;
  opacity: 0.8;
}
::ng-deep .optimized-generator-modal .ant-modal-close-x:hover {
  opacity: 1;
}
::ng-deep .optimized-generator-modal .ant-modal-body {
  min-height: 400px !important;
  max-height: 70vh !important;
  overflow-y: auto !important;
  padding: 24px !important;
}
.wizard-steps {
  margin-bottom: 32px;
  padding: 0 24px;
}
.modal-content {
  min-height: 450px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  padding: 0 8px;
}
.step-container {
  padding: 0 16px;
}
.step-container h3 {
  font-size: 20px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.step-container h3 nz-icon {
  font-size: 24px;
  color: #1890ff;
}
.step-container .step-description {
  color: #595959;
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.6;
}
.step-json-input .quick-samples {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
}
.step-json-input .quick-samples .samples-label {
  font-weight: 500;
  color: #595959;
}
.step-json-input .json-textarea {
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 12px;
  border-radius: 6px;
  margin-bottom: 12px;
}
.step-json-input .error-alert {
  margin-bottom: 16px;
}
.step-json-input .info-card {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
}
.step-json-input .info-card nz-icon {
  margin-right: 8px;
}
.step-analysis .analysis-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.step-analysis .analysis-summary .summary-card {
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s;
}
.step-analysis .analysis-summary .summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.step-analysis .analysis-summary .strategy-card .strategy-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.step-analysis .analysis-summary .strategy-card .strategy-content .strategy-title {
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 500;
}
.step-analysis .warnings-alert {
  margin-bottom: 24px;
}
.step-analysis .warnings-alert ul {
  margin: 8px 0 0;
  padding-left: 20px;
}
.step-analysis .warnings-alert ul li {
  margin-bottom: 4px;
  color: #ad6800;
}
.step-analysis .entities-section {
  margin-bottom: 24px;
}
.step-analysis .entities-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.step-analysis .entities-section h4 nz-icon {
  color: #1890ff;
}
.step-analysis .entities-section .entities-collapse .entity-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: 24px;
}
.step-analysis .entities-section .entities-collapse .entity-header .entity-name {
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.step-analysis .entities-section .entities-collapse .entity-header .entity-badges {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.step-analysis .entities-section .entities-collapse .entity-details {
  padding: 12px 0;
}
.step-analysis .entities-section .entities-collapse .entity-details .detail-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 13px;
}
.step-analysis .entities-section .entities-collapse .entity-details .detail-row strong {
  min-width: 150px;
  color: #595959;
}
.step-analysis .entities-section .entities-collapse .entity-details .detail-row code {
  background: #f5f5f5;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-family:
    "Consolas",
    "Monaco",
    monospace;
}
.step-analysis .layout-preview-section {
  margin-top: 24px;
}
.step-analysis .layout-preview-section h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.step-analysis .layout-preview-section h4 nz-icon {
  color: #52c41a;
}
.step-analysis .layout-preview-section .layout-stats {
  display: flex;
  justify-content: space-around;
  padding: 20px 0;
  background:
    linear-gradient(
      135deg,
      #f5f7fa 0%,
      #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 16px;
}
.step-analysis .layout-preview-section .layout-stats .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.step-analysis .layout-preview-section .layout-stats .stat-item nz-icon {
  font-size: 32px;
}
.step-analysis .layout-preview-section .layout-stats .stat-item .stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #262626;
}
.step-analysis .layout-preview-section .layout-stats .stat-item .stat-label {
  font-size: 13px;
  color: #595959;
  font-weight: 500;
}
.step-analysis .layout-preview-section .strategy-description-card {
  background: #fff7e6;
  border: 1px solid #ffd591;
}
.step-analysis .layout-preview-section .strategy-description-card p {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #ad6800;
}
.step-analysis .layout-preview-section .strategy-description-card p nz-icon {
  font-size: 18px;
}
.step-config .config-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.step-config .config-sections .config-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.step-config .config-sections .config-card label[nz-checkbox] {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 0;
}
.step-config .config-sections .config-card label[nz-checkbox] nz-icon {
  margin-right: 6px;
}
.step-config .config-sections .config-card nz-form-extra {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}
.step-generation .generation-ready {
  padding: 20px 0;
}
.step-generation .generation-ready .generation-summary {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
}
.step-generation .generation-ready .generation-summary .summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #e8e8e8;
}
.step-generation .generation-ready .generation-summary .summary-item:last-child {
  border-bottom: none;
}
.step-generation .generation-ready .generation-summary .summary-item strong {
  color: #595959;
}
.step-generation .generation-ready .generation-summary .summary-item span {
  font-weight: 600;
  color: #1890ff;
}
.modal-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}
.modal-content::-webkit-scrollbar {
  width: 8px;
}
.modal-content::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}
.modal-content::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 4px;
}
.modal-content::-webkit-scrollbar-thumb:hover {
  background: #8c8c8c;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.step-container {
  animation: fadeIn 0.3s ease-out;
}
/*# sourceMappingURL=optimized-auto-screen-generator.component.css.map */
